import type { AppCardData } from './types';

export const CRITICALITY_LABEL: Record<AppCardData['criticality'], string> = {
  standard: 'Standard',
  important: 'Important',
  business_critical: 'Business-critical',
};
